import { render, staticRenderFns } from "./ObservationsPage.vue?vue&type=template&id=dc0592ec&scoped=true"
import script from "./ObservationsPage.vue?vue&type=script&lang=js"
export * from "./ObservationsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0592ec",
  null
  
)

export default component.exports